import { PendingIcon } from 'entities/campaign';
import { getFormattedDate } from 'shared/lib/format';
import { Tooltip } from 'shared/ui/Tooltip';

interface PendingTooltipProps {
  appliesAt: string | null;
  isShowClock: boolean;
}

export function PendingScheduleTooltip({ appliesAt, isShowClock }: PendingTooltipProps) {
  const formattedAppliesAt = appliesAt && getFormattedDate(appliesAt);
  const tooltipContent = `Call center hours changes will be applied on Monday, ${formattedAppliesAt}`;

  return (
    <>
      {isShowClock && (
        <Tooltip
          placement="bottom-end"
          contentClass="!text-left"
          content={tooltipContent}
        >
          <PendingIcon className="ml-2" />
        </Tooltip>
      )}
    </>
  );
}
